export default defineNuxtPlugin(async () => {
  useSeo()
})
